<template>
  <div>
    <b-card :title="$t('settings.licenseExpiry.title')">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-card
            bg-variant="primary"
            text-variant="white"
          >
            <b-card-text>
              <h3>0</h3>
              <p>{{ $t('settings.licenseExpiry.total_offices') }}</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-card
            bg-variant="success"
            text-variant="white"
          >
            <b-card-text>
              <h3>0</h3>
              <p>{{ $t('settings.licenseExpiry.active_licenses') }}</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-card
            bg-variant="warning"
            text-variant="white"
          >
            <b-card-text>
              <h3>0</h3>
              <p>{{ $t('settings.licenseExpiry.expiring_soon_30') }}</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-card
            bg-variant="danger"
            text-variant="white"
          >
            <b-card-text>
              <h3>0</h3>
              <p>{{ $t('settings.licenseExpiry.expired_count') }}</p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>

      <b-tabs class="mt-2">
        <b-tab
          :title="$t('settings.licenseExpiry.expiring_licenses')"
          active
        >
          <b-table
            :items="[]"
            :fields="expiringFields"
            show-empty
            :empty-text="$t('common.no_data')"
          />
        </b-tab>
        <b-tab :title="$t('settings.licenseExpiry.expired_licenses')">
          <b-table
            :items="[]"
            :fields="expiredFields"
            show-empty
            :empty-text="$t('common.no_data')"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BTabs, BTab, BTable,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardText, BRow, BCol, BTabs, BTab, BTable,
  },
  data() {
    return {
      expiringFields: [
        { key: 'office_name', label: this.$t('settings.engineeringOffice.office_name') },
        { key: 'license_expiry_date', label: this.$t('settings.engineeringOffice.license_expiry_date') },
        { key: 'days_until_expiry', label: this.$t('settings.engineeringOffice.days_until_expiry') },
      ],
      expiredFields: [
        { key: 'office_name', label: this.$t('settings.engineeringOffice.office_name') },
        { key: 'license_expiry_date', label: this.$t('settings.engineeringOffice.license_expiry_date') },
      ],
    }
  },
}
</script>
